import { render, staticRenderFns } from "./CommandDestinationsTable.vue?vue&type=template&id=60bfaf3d&"
import script from "./CommandDestinationsTable.vue?vue&type=script&lang=ts&"
export * from "./CommandDestinationsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports